import React from "react";
import { Link } from "react-router-dom";

export default function MarketingFooter() {
  return (
    <footer
      data-testid="marketing-footer"
      className="bg-[#1A3A5C] text-[#E8ECF2] mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-8 w-8 rounded-md bg-[#F8F9FC] flex items-center justify-center">
              <span className="font-display font-bold text-[#1A3A5C] text-sm">W</span>
            </div>
            <span className="font-display text-xl font-bold tracking-tighter text-white">
              wylo
            </span>
          </div>
          <p className="text-sm text-[#E8ECF2]/70 leading-relaxed max-w-xs">
            WYLO addresses the 'what now' of distraction, while prioritising your privacy protection.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-[0.2em] text-[#E8ECF2]/60 mb-4">
            Product
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/features" className="hover:text-white" data-testid="footer-features">Features</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/integrations" className="hover:text-white">Integrations</Link></li>
            <li><Link to="/users" className="hover:text-white" data-testid="footer-users">Users</Link></li>
            <li><Link to="/resources" className="hover:text-white" data-testid="footer-resources">Resources</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-[0.2em] text-[#E8ECF2]/60 mb-4">
            Company
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/our-story" className="hover:text-white" data-testid="footer-our-story">Our Story</Link></li>
            <li><Link to="/careers" className="hover:text-white">Careers</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/investors" className="hover:text-white">Investors</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-[0.2em] text-[#E8ECF2]/60 mb-4">
            Legal
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/legal/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-white">Terms of Service</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-white">Cookie Policy</Link></li>
            <li>
              <button
                onClick={() => {
                  localStorage.removeItem("wylo_cookie_consent");
                  window.location.reload();
                }}
                className="hover:text-white"
                data-testid="footer-cookie-settings"
              >
                Cookie Settings
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#F8F9FC]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#E8ECF2]/50">
          <p>© {new Date().getFullYear()} WYLO. Registered in Ireland.</p>
          <p>Made for people. Built for focused work.</p>
        </div>
      </div>
    </footer>
  );
}
